import { deepcopy, deepEqual } from '@/utils/deep';

export class ChangeHook {
  private hooks: Array<{ value: () => any, cb: (before?: any, after?: any) => void, options: { deep: boolean } }> = []

  watch<T>(value: () => T, cb: (before: T, after: T) => void, options = { deep: false }) {
    this.hooks.push({ value, cb, options })
  }

  async flush(f: () => void) {
    const values: any[] = []
    const returnValues: any[] = []
    for (const { value, options: { deep } } of this.hooks) {
      values.push(deep ? deepcopy(value()) : value())
    }
    await f()
    for (let i = 0; i < values.length; ++i) {
      const { value, cb, options: { deep } } = this.hooks[i]
      const before = values[i]
      const after = value()
      if (deep ? !deepEqual(after, before) : after !== before) {
        returnValues.push(await cb(before, after))
      }
    }
    return returnValues
  }
}
